import { render, staticRenderFns } from "./GraficoBarraLateral.vue?vue&type=template&id=6a839c0c&"
import script from "./GraficoBarraLateral.vue?vue&type=script&lang=ts&"
export * from "./GraficoBarraLateral.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports